export default "__VITE_ASSET__DVUKEcnh__"